import { render, staticRenderFns } from "./EmployeeBadgesAvailable.vue?vue&type=template&id=b8ba1270&scoped=true"
import script from "./EmployeeBadgesAvailable.vue?vue&type=script&lang=js"
export * from "./EmployeeBadgesAvailable.vue?vue&type=script&lang=js"
import style0 from "./EmployeeBadgesAvailable.vue?vue&type=style&index=0&id=b8ba1270&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8ba1270",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8ba1270')) {
      api.createRecord('b8ba1270', component.options)
    } else {
      api.reload('b8ba1270', component.options)
    }
    module.hot.accept("./EmployeeBadgesAvailable.vue?vue&type=template&id=b8ba1270&scoped=true", function () {
      api.rerender('b8ba1270', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/views/rh/gestion/employee/career/EmployeeBadgesAvailable.vue"
export default component.exports